module.exports = __webpack_public_path__ + "static/img/dcxt-details.0acb384.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/dcxt-details.png
// module id = 6wJn
// module chunks = 0